import { Select } from 'antd'
import { useConfiguredOptions } from '../hooks'
import type { SelectedBySelectProps } from '../types'

/** Stores a single configured option ID and clears the selection to null. */
function SelectedBySelect({
  accessibility,
  disabled,
  field,
  onBlur,
  onChange,
  value,
}: SelectedBySelectProps) {
  const optionId = typeof value === 'string' ? value : undefined
  const options = useConfiguredOptions(field, optionId ? [optionId] : [])

  return (
    <Select
      {...accessibility}
      allowClear={!disabled}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(selection: string | undefined) => onChange(selection ?? null)}
      options={options}
      style={{ width: '100%' }}
      value={optionId}
    />
  )
}

export default SelectedBySelect
